/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import {
	RichText,
	useBlockProps,
	BlockControls,
} from '@wordpress/block-editor';
import { ToolbarDropdownMenu, ToolbarGroup } from '@wordpress/components';
import {
	justifyLeft,
	justifyRight,
	justifyCenter,
	stretchWide,
} from '@wordpress/icons';

/**
 * External dependencies
 */
import classNames from 'classnames';

const ALIGNMENT_CONTROLS = {
	left: {
		icon: justifyLeft,
		title: __( 'Align Left', 'formello' ),
	},
	center: {
		icon: justifyCenter,
		title: __( 'Align Center', 'formello' ),
	},
	right: {
		icon: justifyRight,
		title: __( 'Align Right', 'formello' ),
	},
	wide: {
		icon: stretchWide,
		title: __( 'Wide', 'formello' ),
	},
};
const DEFAULT_CONTROLS = [ 'left', 'right', 'center', 'wide' ];

const Edit = ( { attributes, setAttributes } ) => {
	const { align } = attributes;
	const buttonClass = classNames( 'wp-element-button', 'align' + align );
	const blockProps = useBlockProps( { className: buttonClass } );

	return (
		<button { ...blockProps }>
			<BlockControls>
				<ToolbarGroup>
					<ToolbarDropdownMenu
						icon={ ALIGNMENT_CONTROLS[ align ].icon }
						label={ __( 'Align' ) }
						controls={ DEFAULT_CONTROLS.map( ( control ) => {
							const isActive = align === control;

							return {
								...ALIGNMENT_CONTROLS[ control ],
								isActive,
								onClick: () =>
									setAttributes( { align: control } ),
							};
						} ) }
					/>
				</ToolbarGroup>
			</BlockControls>
			<RichText
				tagName="span"
				value={ attributes.text }
				onChange={ ( val ) => setAttributes( { text: val } ) }
				placeholder={ __( 'Enter close text…', 'popper' ) }
				allowedFormats={ [ 'core/bold', 'core/italic' ] }
				multiline={ false }
			/>
		</button>
	);
};
export default Edit;
